import { Button } from "react-bootstrap";
import { BiEdit, BiTrash } from "react-icons/bi";

const UsuarioCard = ({ usuario, onEditar, onRemover }) => {
  return (
    <div className="usuario-card">
      <div className="usuario-info">
        <strong>{usuario.userName}</strong>
        <small>{usuario.userEmail}</small>

        <div className="usuario-meta">
          <span>{usuario.tipo}</span>
          <span>ID: {usuario.userMatriculaId}</span>
        </div>
      </div>

      {(onEditar || onRemover) && <div className="usuario-actions">
        {onEditar && (
        <Button size="sm" variant="outline-primary" onClick={onEditar}>
          <BiEdit />
        </Button>
        )}
        {onRemover && (
        <Button size="sm" variant="outline-danger" onClick={onRemover}>
          <BiTrash />
        </Button>
        )}
      </div>}
    </div>
  );
};

export default UsuarioCard;
